<script lang="ts">
  import { Popover, List, ListItem } from 'framework7-svelte'
  import fmt from '@yakit/core/formatters'
  import { Icon } from '@yakit/ui/svelte'
  import { Link } from 'framework7-svelte'
  import injector from '~/injector'
  import { AuditTrail } from '~/types/entities/AuditTrail'

  export let entityId: string
  export let entityType: string

  export let popoverId: string = 'created-info-popover'

  const ky = injector.get('ky')
  let popoverOpened: boolean = false

  let createdBy: string | undefined
  let editedBy: string | undefined 
  let createdDate: string | undefined
  let editedDate: string | undefined
  let createdById: string | undefined
  let editedById: string | undefined
  let entity: AuditTrail | undefined

  async function onPopoverOpen(instance: any): Promise<void> {
    entity = await ky
      .get(
        `${entityType}/${entityId}?includes=createdByUser.displayName,editedByUser.displayName,createdByUser.id,editedByUser.id,createdDate,editedDate`
      )
      .json()
    createdDate = entity.createdDate ? fmt.datetime(entity.createdDate) : ''
    editedDate = entity.editedDate ? fmt.datetime(entity.editedDate) : ''
    createdBy = entity.createdByUser?.displayName || null
    editedBy = entity.editedByUser?.displayName || null
    createdById = entity.createdByUser?.id || null
    editedById = entity.editedByUser?.id || null
  }

  function onClose(): void {
    popoverOpened = false
  }

  function handleTriggerClick(event: Event): void {
    event.preventDefault()
    popoverOpened = true
  }
</script>

<!-- Trigger element slot -->
<Link
  class="popover-trigger"
  popoverOpen={`#${popoverId}`}
  on:click={handleTriggerClick}
  role="button"
>
  <slot />
</Link>

<Popover
  id={popoverId}
  bind:opened={popoverOpened}
  {onPopoverOpen}
  class="created-info-popover"
  closeByOutsideClick={true}
  closeByBackdropClick={true}
  closeOnEscape={true}
>
  {#if entity}
    <div class="created-info-content">
      <List>
        {#if createdBy || entity.createdDate}
          <ListItem>
            <div slot="title" class="info-label">
              <Icon icon="add_circle_outline" size="16" />
              Created
            </div>
            <div slot="after" class="info-values">
              {#if createdBy}
                <div class="info-value">{createdBy} | {createdById}</div>
              {/if}
              {#if entity.createdDate}
                <div class="info-value">{createdDate}</div>
              {/if}
            </div>
          </ListItem>
        {/if}

        {#if editedBy || entity.editedDate}
          <ListItem>
            <div slot="title" class="info-label">
              <Icon icon="edit" size="16" />
              Edited
            </div>
            <div slot="after" class="info-values">
              {#if editedBy}
                <div class="info-value">{editedBy} | {editedById}</div>
              {/if}
              {#if entity.editedDate}
                <div class="info-value">{editedDate}</div>
              {/if}
            </div>
          </ListItem>
        {/if}
      </List>
    </div>
  {/if}
</Popover>

<style lang="scss">
  :global(.popover.created-info-popover) {
    --f7-popover-width: 250px;
  }

  .created-info-content {
    padding: 0;
    background: white;
    color: #333;
    min-width: 200px;
  }

  :global(.created-info-content .list) {
    margin: 0;
  }

  .info-label {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #333;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .info-values {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    text-align: right;
  }

  .info-value {
    font-size: 13px;
    color: #333;
    line-height: 1.4;

    &:not(:last-child) {
      margin-bottom: 2px;
    }
  }
</style>
